import { useParams } from "react-router-dom";
import CardFormEdit from "./editform";

function CardEdit () {
    
    const params = useParams();

    var param_id = params.id
    var plan_id = -1;
    if (param_id){
      var tmp_id = parseInt(param_id)
      if (!Number.isNaN(tmp_id)){
        plan_id = tmp_id
      }
  
    }
    
    return <CardFormEdit plan_id={plan_id} ></CardFormEdit>

}

export default CardEdit;